/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarydeleteconfirmdescription4Inputs */

const en_medialibrarydeleteconfirmdescription4 = /** @type {(inputs: Medialibrarydeleteconfirmdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It will be removed from your media library. This can't be undone.`)
};

const de_medialibrarydeleteconfirmdescription4 = /** @type {(inputs: Medialibrarydeleteconfirmdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Inhalt verschwindet aus deiner Mediathek. Das kannst du nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "It will be removed from your media library. This can't be undone." |
*
* @param {Medialibrarydeleteconfirmdescription4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarydeleteconfirmdescription4 = /** @type {((inputs?: Medialibrarydeleteconfirmdescription4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarydeleteconfirmdescription4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarydeleteconfirmdescription4(inputs)
	return de_medialibrarydeleteconfirmdescription4(inputs)
});
export { medialibrarydeleteconfirmdescription4 as "mediaLibraryDeleteConfirmDescription" }